import logo1998 from "../../assets/img/historicEvents/LogoNoWayOut/1998.png";
import logo2000 from "../../assets/img/historicEvents/LogoNoWayOut/2000.png";
import logo2001 from "../../assets/img/historicEvents/LogoNoWayOut/2001.png";
import logo2002 from "../../assets/img/historicEvents/LogoNoWayOut/2002.png";
import logo2003 from "../../assets/img/historicEvents/LogoNoWayOut/2003.png";
import logo2004 from "../../assets/img/historicEvents/LogoNoWayOut/2004.png";
import logo2005 from "../../assets/img/historicEvents/LogoNoWayOut/2005.png";
import logo2006 from "../../assets/img/historicEvents/LogoNoWayOut/2006.png";
import logo2007_2009 from "../../assets/img/historicEvents/LogoNoWayOut/2007-2009.png";
import logo2012 from "../../assets/img/historicEvents/LogoNoWayOut/2012.png";

export const noWayOutDetail = {
  "no-way-out": {
    id: "no-way-out",
    title: "No Way Out",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "no-way-out",
        items: [
          {
            id: "no-way-out-1998",
            title: "No Way Out of Texas",
            description: "In Your House 1998",
            imgUrl: logo1998,
          },
          {
            id: "no-way-out-2000",
            title: "No Way Out",
            description: "Let the Game Begin. 2000",
            imgUrl: logo2000,
          },
          {
            id: "no-way-out-2001",
            title: "No Way Out",
            description: "2001",
            imgUrl: logo2001,
          },
          {
            id: "no-way-out-2002",
            title: "No Way Out",
            description: "2002",
            imgUrl: logo2002,
          },
          {
            id: "no-way-out-2003",
            title: "No Way Out",
            description: "2003",
            imgUrl: logo2003,
          },
          {
            id: "no-way-out-2004",
            title: "No Way Out",
            description: "Wanted For: Lying. Cheating. Stealing. 2004",
            imgUrl: logo2004,
          },
          {
            id: "no-way-out-2005",
            title: "No Way Out",
            description: "2005",
            imgUrl: logo2005,
          },
          {
            id: "no-way-out-2006",
            title: "No Way Out",
            description: "2006",
            imgUrl: logo2006,
          },
          {
            id: "no-way-out-2007",
            title: "No Way Out",
            description: "2007 - 2009",
            imgUrl: logo2007_2009,
          },
          {
            id: "no-way-out-2012",
            title: "No Way Out",
            description: "Yes! Yes! Yes! 2012",
            imgUrl: logo2012,
          },
        ],
      },
    ],
  },
};
